export default function createTabsPalette(theme, current, base) {
    return {
        tabs: {
            scrollShadowBackground: base.background,
            filled: {
                button: {},
                tab: {
                    list: {
                        borderColor: base.gray[200],
                    },
                },
                line: {
                    list: {
                        borderColor: base.gray[200],
                    },
                    item: {
                        active: {
                            borderColor: current[500],
                        },
                    },
                },
            },
            faded: {
                button: {},
                tab: {
                    list: {
                        borderColor: current[200],
                    },
                    item: {
                        active: {
                            borderColor: current[200],
                        },
                    },
                },
                line: {
                    list: {
                        borderColor: base.gray[200],
                    },
                    item: {
                        active: {
                            borderColor: current[200],
                        },
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=tabs.js.map